<template>
  <div class="card p-4">
    <div class="text-center process mx-auto">
      <img width="218" height="150" class="mb-4" alt="uploading" :src="uploadingImage" />
      <h5 class="mb-4">{{ $t('global.importData.uploading') }}</h5>
      <p class="my-3" v-if="false">{{ fileName }}</p>
      <div class="text-start">
        <McProgressBar height="8px" :value="percentage" />
        <div class="d-flex align-items-center justify-content-between mt-4">
          <span class="__filesize">{{ fileUploadedSize }} / {{ fileSize }} {{ 'MB' }}</span>
          <span class="__percentage">{{ percentage }}%</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import uploadingImage from '@/assets/images/upload-in-progress.png'
import McProgressBar from '@/components/McProgressBar'
import { IMPORT_SERVICE_SCHEDULE } from '@/services/api/maintenance/serviceSchedules'

export default {
  components: {
    McProgressBar,
  },
  data() {
    return {
      fileSize: 0,
      fileUploadedSize: 0,
      percentage: 0,
      fileName: '',
      uploadingImage,
    }
  },
  mounted() {
    this.pollData()
  },
  methods: {
    pollData() {
      const fileProp = this.$store.state.maintenance.file
      this.fileSize = fileProp.filesize
      const param = [15, 25, 50, 70, 90, 100]
      for (let i = 0; i < param.length; i++) {
        setTimeout(() => {
          this.fileUploadedSize = ((this.fileSize * param[i]) / 100).toFixed(2)
          this.percentage = param[i]
          if (param[i] === 100) {
            setTimeout(async () => {
              const res = await this.$apollo.mutate({
                mutation: IMPORT_SERVICE_SCHEDULE,
                variables: {
                  input: {
                    filebase64: fileProp.filebase64,
                    filename: fileProp.filename,
                  },
                },
              })
              if (!res.data.importServiceSchedules.isSuccessful) {
                this.$router.push({ name: 'Service Schedule Import' })
                if (res.data.importServiceSchedules.message == 'Imported file data is empty.') {
                  this.$mcToast.error(this.$t('global.importResult.emptyData'))
                } else this.$mcToast.error(res.data.importServiceSchedules.message)
                return
              }
              this.$store.commit(
                'maintenance/SET_IMPORT_RESULT',
                res.data.importServiceSchedules.importServiceSchedules
              )

              this.$router.push({ name: 'Service Schedule Import Result' })
            }, 1000)
          }
        }, i * 500)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.process {
  max-width: 300px;
}

.__filesize {
  color: $teal-300;
}

.__percentage {
  color: $blue;
  font-size: 16px;
  font-weight: 600;
}
</style>
